<template>
  <TopGradientBlockLayout>
    <template v-slot:top>
      <PasswordGuard/>
    </template>
    <div class="text-xl font-bold text-text leading-tight mb-11">{{ $t('title') }}</div>
    <div class="relative">
      <PasswordGuardOverlay/>
      <div class="bg-line px-6 py-4 -mx-6 rounded text-sm text-text-ternary
                  session-grid">
        <div></div>
        <div>{{ $t('device') }}</div>
        <div>{{ $t('haveSeen') }}</div>
        <div>{{ $t('created') }}</div>
        <div>{{ $t('location') }}</div>
        <div></div>
      </div>
      <div class="divide-y divide-border">
        <SessionItem v-for="(item,i) in sessions"
                     :key="i"
                     class="session-grid"
                     :item="item"
                     @changeName="changeName($event)"
                     @delete="deleteUserSession($event)"/>
      </div>
    </div>
  </TopGradientBlockLayout>

</template>

<script>
import {mapActions} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import PasswordGuard from "@/components/common/PasswordGuard/PasswordGuard";
import PasswordGuardOverlay from "@/components/common/PasswordGuard/PasswordGuardOverlay";

export default {
  name: "Sessions",
  components: {
    PasswordGuardOverlay,
    PasswordGuard,
    TopGradientBlockLayout,
    SessionItem: () => import('@/components/cabinet/ProfileSettings/Sessions/SessionItem/SessionItem.vue'),
  },
  data() {
    return {
      sessions: []
    }
  },
  methods: {
    ...mapActions('cabinet/user', ['getUserSessions', 'updateSession', 'deleteSession']),
    getSessions() {
      this.getUserSessions().then(({body}) => {
        if (body.success) {
          this.sessions = body.data.rows;
        } else {
          throw 'Error in getting sessions'
        }
      })
    },
    changeName(data) {
      this.updateSession(data).then(({body}) => {
        if (body.success) {
          this.sessions = this.sessions.map(item => {
            if (item.id === data.id) {
              return {...item, name: data.name}
            } else {
              return item
            }
          })
        }
      })
    },
    deleteUserSession(id) {
      this.deleteSession(id).then(({body}) => {
        if (body.success) {
          this.getSessions()
        }
      })
    }
  },
  mounted() {
    this.getSessions()
  },
  i18n: {
    messages: {
      en: {
        title: 'Active devices',
        device: 'Device',
        haveSeen: 'Have seen at',
        created: 'Created at',
        location: 'Location'
      },
      ru: {
        title: 'Активные устройства',
        device: 'Устройство',
        haveSeen: 'Был в сети',
        created: 'Создан',
        location: 'Локация'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.session-grid {
  display: grid;
  grid-template-columns: 4rem 24.8% 15% 20% auto auto;
  grid-column-gap: 1.5rem;
}
</style>